/**
 * Prevent removing the block when deleting block content
 *
 * @param state EditorState<any>
 * @param dispatch CommandDispatch
 * @returns boolean
 */
export function deleteBlockContent(isNodeAWrappingBlockNode) {
  return function (state, dispatch) {
    var tr = state.tr,
      _state$selection = state.selection,
      $from = _state$selection.$from,
      $to = _state$selection.$to,
      doc = state.doc;
    if ($from.pos === $to.pos) {
      return false;
    }
    var selectionCrossesWrappingBlockNode = false;
    doc.nodesBetween($from.pos, $to.pos, function (node, pos) {
      // Optimisation. If selection crosses wrapping block node
      // short circuit the loop by returning false
      if (selectionCrossesWrappingBlockNode) {
        return false;
      }
      if (isNodeAWrappingBlockNode(node)) {
        selectionCrossesWrappingBlockNode = true;
        return false;
      }
    });
    if (!selectionCrossesWrappingBlockNode) {
      return false;
    }
    tr.delete($from.pos, $to.pos);
    if (dispatch) {
      dispatch(tr);
    }
    return true;
  };
}